var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIwdIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0.777754V6.99978C23 7.20606 22.9135 7.40388 22.7594 7.54974C22.6054 7.6956 22.3964 7.77754 22.1786 7.77754C21.9607 7.77754 21.7518 7.6956 21.5978 7.54974C21.4437 7.40388 21.3572 7.20606 21.3572 6.99978V2.65506L12.9028 10.6611C12.8265 10.7334 12.7359 10.7907 12.6362 10.8299C12.5365 10.869 12.4296 10.8892 12.3216 10.8892C12.2137 10.8892 12.1068 10.869 12.0071 10.8299C11.9074 10.7907 11.8168 10.7334 11.7405 10.6611L8.21458 7.32158L1.40302 13.7721C1.24889 13.918 1.03984 14 0.821869 14C0.603896 14 0.39485 13.918 0.24072 13.7721C0.0865895 13.6261 0 13.4282 0 13.2218C0 13.0154 0.0865895 12.8175 0.24072 12.6716L7.63343 5.67177C7.70972 5.59946 7.80031 5.54209 7.90003 5.50295C7.99974 5.46381 8.10663 5.44366 8.21458 5.44366C8.32253 5.44366 8.42941 5.46381 8.52913 5.50295C8.62885 5.54209 8.71944 5.59946 8.79573 5.67177L12.3216 9.01125L20.1959 1.55551H15.6073C15.3894 1.55551 15.1805 1.47357 15.0265 1.32771C14.8724 1.18185 14.7859 0.984027 14.7859 0.777754C14.7859 0.571481 14.8724 0.373656 15.0265 0.227799C15.1805 0.0819418 15.3894 0 15.6073 0H22.1786C22.3964 0 22.6054 0.0819418 22.7594 0.227799C22.9135 0.373656 23 0.571481 23 0.777754Z",
    fill: "#7B68EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIwdIcon03);
export default __webpack_public_path__ + "static/media/iwd-icon-03.0554723b4ee867858e630c15e6e98e2b.svg";
export { ForwardRef as ReactComponent };